﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartVaultManagerContract = exports.SmartVaultInfo = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const SmartVaultManagerABI_1 = require("./abi/SmartVaultManagerABI");
class SmartVaultInfo {
}
exports.SmartVaultInfo = SmartVaultInfo;
class SmartVaultManagerContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, SmartVaultManagerABI_1.SmartVaultManagerABI.GetABI());
    }
    getSmartVaultsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getSmartVaultsForAddressAsync(0, "");
        });
    }
    getSmartVaultsForAddressAsync(skip, address) {
        return __awaiter(this, void 0, void 0, function* () {
            let addrs = this._address;
            if (address)
                addrs = address;
            let rawInfo = yield this._call("viewSmartVaults", skip + "", addrs);
            const zero = "0x0000000000000000000000000000000000000000";
            let result = [];
            for (const raw of rawInfo) {
                if (raw.addrs == zero)
                    continue;
                const info = new SmartVaultInfo();
                info.debt = this._toDecimal(raw.debt);
                info.coll = this._toDecimal(raw.coll);
                info.totalDebt = this._toDecimal(raw.totalDebt);
                info.FCRIndex = this._toDecimal(raw.FCRIndex);
                info.redeemDeltaDebtIndex = this._toDecimal(raw.redeemDeltaDebtIndex);
                info.redeemDeltaCollIndex = this._toDecimal(raw.redeemDeltaCollIndex);
                info.debtForRepay = this._toDecimal(raw.debtForRepay);
                info.plsvBalance = this._toDecimal(raw.plsvBalance);
                info.plsvSupply = this._toDecimal(raw.plsvSupply);
                info.totalLiqidatedColl = this._toDecimal(raw.totalLiqidatedColl);
                info.closeVaultTimestamp = raw.closeVaultTimestamp;
                info.addrs = raw.addrs;
                info.name = raw.name;
                info.isLiquidated = raw.isLiquidated;
                info.needExtSync = raw.needExtSync;
                result.push(info);
            }
            return result;
        });
    }
    changeSmartVaultAsync(valueEth, sourceVault, targetVault, ownFundsEth, maxMainFeeEth) {
        return __awaiter(this, void 0, void 0, function* () {
            const valueWEI = this._toWei(valueEth);
            const ownFundsWei = this._toWei(ownFundsEth);
            const maxMainFeeWei = this._toWei(maxMainFeeEth);
            const result = yield this._pay(valueWEI, "changeSmartVault", sourceVault, targetVault, ownFundsWei, maxMainFeeWei);
            return result;
        });
    }
}
exports.SmartVaultManagerContract = SmartVaultManagerContract;
//# sourceMappingURL=SmartVaultManagerContract.js.map